"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormButtons(_a) {
    var onSubmit = _a.onSubmit, onDelete = _a.onDelete, model = _a.model, active = _a.active;
    return react_1.default.createElement(storybook_1.Forms.Buttons, { className: 'ml-auto items-center', loading: model.submitting, errors: model.errors, submit: onSubmit },
        Boolean(active.id) &&
            react_1.default.createElement(storybook_1.Buttons.Button, { className: 'storybook-chapters-form-remove', onClick: onDelete }, "Verwijder"),
        react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', disabled: model.submitting, onClick: onSubmit }, "Opslaan"));
}
exports.default = FormButtons;
